import React from "react"
import { LinkContainer } from "react-router-bootstrap"
import { Button, Glyphicon } from "react-bootstrap"

export const OrderStatus = [ "NEW", "TERKIRIM", "BATAL" ]

export const ButtonAdd = ({ to, onClick }) => (
  <LinkContainer to={to}>
    <Button bsSize="small" onClick={onClick} >
      <Glyphicon glyph="plus" />
    </Button>
  </LinkContainer>
)

export const getRecords = records => {
  return records ? records.valueSeq() : []
}

export const processInt = val => {
  return parseInt(val === "" || isNaN(val) ? 0 : val, 10)
}

export const socket_protocol = process.env.REACT_APP_SOCKET_PROTOCOL || window.location.protocol
export const socket_host = process.env.REACT_APP_SOCKET_HOSTNAME || window.location.hostname
export const socket_port = process.env.REACT_APP_SOCKET_PORT || 53300
export const api_path = "/api"
export const upload_path = api_path + "/uploads"



// WEBPACK FOOTER //
// ./src/components/Common.js